<template>
  <v-container fluid>
    <v-layout>
      <v-flex md4>
        <v-autocomplete
                v-model="selectedBlock"
                :items="blocksList"
                item-text="name"
                item-value="id"
                @change="updateSelectedBlock"
                solo
                label="Search Blocks"
                prepend-inner-icon="search"
                :return-object="true"
        >
        </v-autocomplete>
        <groups></groups>
      </v-flex>
      <v-flex md8 class="pl-5">
        <blocks :blocks-list="blocksList"></blocks>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import groups from '../components/block-build/groups/groups'
  import blocks from '../components/block-build/blocks/blocks'
  import common from "../utils/common";
  export default {
    components: {
      groups,
      blocks
    },
    data () {
      return {
        bots: [],
        blocksList: [],
        selectedBlock: {},
      }
    },
    mounted() {
      this.getBlocksList()
      this.getVariables()
    },
    methods: {
      getBlocksList() {
        this.$http_bot.get('/blocks')
                .then(response=>{
                  this.blocksList = response.data
                })
                .catch(error=>{
                  if (error.response.status === 401) {
                    common.logOut()
                  }
                })
      },
      getVariables() {
        this.$http_bot.get('/blocks/variables/available')
                .then(response=>{
                  const variables = []
                  for (let i = 0; i<response.data.length; i++) {
                    if (response.data[i].variable !== '') {
                      variables.push(response.data[i])
                    }
                  }
                  this.$store.dispatch('setVariables', variables)
                })
                .catch(error=>{
                  if (error.response.status === 401) {
                    common.logOut()
                  }
                })
      },
      updateSelectedBlock() {
        if(this.selectedBlock && this.selectedBlock.id)
        this.$store.dispatch('setSelectedBlock',this.selectedBlock)
      }
    },
    computed: {
      selectedBlockState() {
        return this.$store.state.blocksBuild.selectedBlock
      },
      newBlock() {
        return this.$store.state.blocksBuild.newBlock
      },
      deletedBlock() {
        return this.$store.state.blocksBuild.deletedBlock
      },
      editedBlock() {
        return this.$store.state.blocksBuild.updatedBlockName.name
      }
    },
    watch: {
      selectedBlockState (state) {
        if ( state.id !== this.selectedBlock.id ) {
          this.selectedBlock = {}
        }
      },
      newBlock(state) {
        if (state) {
          this.getBlocksList()
        }
      },
      editedBlock(state) {
        if (state) {
          this.getBlocksList()
        }
      },
      deletedBlock(state) {
        if (state) {
          this.getBlocksList()
        }
      }
    }
  }
</script>
